import React, { useState, useEffect, PureComponent } from "react";
import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";
import "./../../styles/components/dashboard/pie-chart-padding.css";
import { COLORS } from "../../enums/pieChartColors";

function DgPieChart({ data, value, percentageInfo = 0 }) {
  const [formattedData, setFormattedData] = useState([]);

  useEffect(() => {
    if (data) {
      const filteredValues = data.map((item) => ({
        name: item.strategyName,
        value: parseFloat(item[value]),
      }));

      let availableSpace = 100;

      data.map((item) => {
        availableSpace = availableSpace - item[value];
      });

      if (availableSpace > 0) {
        filteredValues.push({
          name: "Available",
          value: availableSpace,
        });
      }

      setFormattedData(filteredValues);
    }
  }, [data]);

  const onPieEnter = () => {};

  return (
    <>
      <div className="component pie-chart-padding">
        <div className="pie-wrapper">
          <PieChart width={180} height={260} onMouseEnter={onPieEnter}>
            <Pie
              data={formattedData}
              cx={90}
              cy={90}
              innerRadius={68}
              outerRadius={84}
              fill="#012B45"
              paddingAngle={10}
              dataKey={"value"}
              cornerRadius={40}
              stroke="none"
            >
              {formattedData.map((entry, index) => {
                const color =
                  entry.name === "Available"
                    ? "green"
                    : COLORS[index % COLORS.length];
                return <Cell key={`cell-${index}`} fill={color} />;
              })}
            </Pie>
            {/* <Legend
              iconSize={10}
              layout="horizontal"
              verticalAlign="bottom"
              align="center"
              margin={{ top: 0, left: 0, right: 0, bottom: 0 }}
            /> */}
            <Tooltip
              content={({ payload }) => {
                return (
                  <div>
                    <div
                      style={{
                        position: "relative",
                        color: "#fff",
                      }}
                    />
                    <div
                      style={{
                        color: "#fff",
                        padding: "10px",
                        background: "#021c2d",
                        opacity: 0.96,
                        borderRadius: "20px",
                      }}
                    >
                      <b>{payload?.[0]?.payload?.name}</b>
                      <span className={""}>
                        <p>{payload?.[0]?.payload?.value} %</p>
                      </span>
                    </div>
                  </div>
                );
              }}
            />
          </PieChart>
          <div className="pie-label">
            <div>
              <p className="percentage">
                {" "}
                {`${parseFloat(percentageInfo).toFixed(2)}%`}
              </p>
              <p className="percentage-total">Total</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DgPieChart;
